import React from 'react';
import { DeleteFilled } from '@ant-design/icons';
import {
    Button,
    message,
    Popconfirm,
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function DeletePopupButton({ data, products, formOrder }) {

    const [messageApi, contextHolder] = message.useMessage();
    const queryClient = useQueryClient();
    const { mutate } = useMutation({
        mutationFn: ({ _id }) => {
            axios
                .delete(`/api/cartItem/${_id}`)
                .then(res => {
                    // console.log(res);
                    const cartItems = products.filter(f => f._id !== _id)

                    let grand_total = cartItems.reduce((prev, cur) => prev + cur.total_price , 0);
                    let total = grand_total;
                    let vat = 0;

                    if (formOrder.getFieldValue("vatFlag") === 'ราคารวมภาษี') {
                        total = grand_total / 1.07;
                        vat = grand_total - total;
                    }

                    formOrder.setFieldsValue({
                        ...formOrder.getFieldsValue(true),
                        total,
                        vat,
                        grand_total
                    });
                    queryClient.invalidateQueries(['/api/cartItem/getOrderCartItems'])
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถลบข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        }
    });

    const confirm = (e) => mutate(data);
    // console.log(data);
    // console.log(products);
    return (
        <div>
            {contextHolder}
            <Popconfirm
                title="ลบข้อมูลรายการนี้"
                description="ต้องการจะลบข้อมูลรายการนี้ ใช่ หรือ ไม่?"
                onConfirm={confirm}
                okText="ใช่"
                cancelText="ไม่ใช่"
            >
                <Button danger icon={<DeleteFilled />} type='text' />
            </Popconfirm>
        </div>
    )
}
